import React from 'react';
import Box from '@mui/material/Box';

const ImageTooltip = props => {
  const { updateDate, mediaType } = props;
  return (
    <Box fontSize="12px">
      <Box>Uploaded: {updateDate}</Box>
      <Box>Type: {mediaType}</Box>
    </Box>
  );
};
export default ImageTooltip;
